import React, { useEffect } from 'react';
import { trans, getResourcePath } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-metrics';
import {
  Modal,
  Button,
  CloseButton,
  useModalHandle
} from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Button.css';
import '@spotahome/ui-library/lib/components/Modal.css';
import '@spotahome/ui-library/lib/components/CloseButton.css';
import './ListingUnavailableModal.scss';

const ListingUnavailableModal = () => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();

  useEffect(() => {
    handleModalOpen();
    Metrics.ga.sendEvent('Search', 'unavailable-modal', 'open');
  }, [handleModalOpen]);

  const handleClose = buttonType => {
    Metrics.ga.sendEvent('Search', 'unavailable-modal', buttonType);
    handleModalClose();
  };

  return (
    <Modal isOpen={isModalOpen}>
      <div data-test="301Modal" className="unavailable-listing__container">
        <CloseButton
          className="unavailable-listing__close"
          onClose={() => handleClose('close-button')}
          data-test="301ModalCloseButton"
        />
        <h2 className="unavailable-listing__title">
          {trans('search.listing-unavailable.title')}
        </h2>
        <img
          className="unavailable-listing__image"
          src={getResourcePath('/images/show-rentable-unit/301-door.svg')}
          alt={trans('search.listing-unavailable.alt-text')}
        />
        <p className="unavailable-listing__description">
          {trans('search.listing-unavailable.description')}
        </p>
        <Button
          size="large"
          onClick={() => handleClose('search-button')}
          data-test="301ModalSearchButton"
        >
          {trans('search.listing-unavailable.cta')}
        </Button>
      </div>
    </Modal>
  );
};

export default ListingUnavailableModal;
